
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class HomeView extends Vue {
  @Prop() private screenShow!: number;
  @Prop() private activeTabIndex!: number;
  @Prop() private deep!: boolean;
  @Prop() private chart!: boolean;
  @Prop() private defaultValue!: string;
  radioChartChange() {
    this.$emit('radioChartChange');
  }
  radioDeepChange() {
    this.$emit('radioDeepChange');
  }
}
